import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NeighboursModule } from "../../sb-editor-tools/neighbours/neighbours.module";
import { TranslationModule } from "../../sb-editor-tools/translation/translation.module";
import { ExternComponent } from "./extern.component";
import { ExceptionsModule } from "../../sb-editor-tools/exceptions/exceptions.module";


@NgModule({
    declarations: [
        ExternComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslationModule,
        NeighboursModule,
        ExceptionsModule
    ],
    providers: [],
    exports:[
        ExternComponent
    ]
})
export class ExternModule {}